<template>
  <svg
    id="Component_26_1"
    data-name="Component 26 – 1"
    xmlns="http://www.w3.org/2000/svg"
    width="21.514"
    height="25.607"
    viewBox="0 0 21.514 25.607"
  >
    <path
      id="Subtraction_5"
      data-name="Subtraction 5"
      d="M22942.824,19206.607a.84.84,0,0,1-.322-.064.83.83,0,0,1-.5-.762v-23.951a.832.832,0,0,1,.83-.83h19.854a.832.832,0,0,1,.83.83v23.951a.83.83,0,0,1-.5.762.84.84,0,0,1-.328.063.825.825,0,0,1-.57-.23l-9.359-8.967-9.354,8.967A.834.834,0,0,1,22942.824,19206.607Zm9.93-22.605-1.8,3.689-4.2.508,3.09,2.795-.793,4,3.7-1.963v0l3.711,1.963-.795-4,3.084-2.795-4.2-.508Z"
      transform="translate(-22942 -19181)"
      fill="black"
    />
  </svg>
</template>

<script setup lang="ts">
import IconProps from '@/assets/ts/interfaces/IconProps'

withDefaults( defineProps<IconProps>(), {} )
</script>

<style scoped></style>
